import DashboardProvider from '../providers/DashboardProvider'

var DashboardService = function () {
  return {
    getDashboards: function (id) {
      return DashboardProvider.getDashboards(id)
    },

    getCompanies: function (userId) {
      return DashboardProvider.getCompanies(userId)
    },

    getLastStatus: function (userId, companyId) {
      return DashboardProvider.getLastStatus(userId, companyId)
    },

    getParentsByCompany: function (userId, companyId) {
      return DashboardProvider.getParentsByCompany(userId, companyId)
    },

    getIncidents: function (userId, companyId) {
      return DashboardProvider.getIncidents(userId, companyId)
    },

    getIncidentsSearchItems: function (userId, companyId) {
      return DashboardProvider.getIncidentsSearchItems(userId, companyId)
    },

    getDashboardWidgets: function (userId, companyId) {
      return DashboardProvider.getDashboardWidgets(userId, companyId)
    },

    getAssetOverview: function (userId, companyId) {
      return DashboardProvider.getAssetOverview(userId, companyId)
    },

    getLogicalAssets: function (userId, companyId, featureId) {
      return DashboardProvider.getLogicalAssets(userId, companyId, featureId)
    },

    getLastStatusSearchItems: function (userId, companyId) {
      return DashboardProvider.getLastStatusSearchItems(userId, companyId)
    },

    getLastStatusExport (userId, companyId, config = {}) {
      return DashboardProvider.getLastStatusExport(userId, companyId, config)
    },

    getIncidentsExport (userId, companyId, config = {}) {
      return DashboardProvider.getIncidentsExport(userId, companyId, config)
    },

    getAssetOverviewExport (userId, companyId, config = {}) {
      return DashboardProvider.getAssetOverviewExport(userId, companyId, config)
    },

    getFeatures (userId, companyId) {
      return DashboardProvider.getFeatures(userId, companyId)
    },

    getFeatureData (userId, companyId, featureId, parentId) {
      return DashboardProvider.getFeatureData(userId, companyId, featureId, parentId)
    },

    getFeaturesExport (userId, companyId, featureId, parentId) {
      return DashboardProvider.getFeaturesExport(userId, companyId, featureId, parentId)
    }
  }
}

export default new DashboardService()



// WEBPACK FOOTER //
// ./src/services/DashboardService.js